export default "__VITE_ASSET__3edd9cf0__"